import { Icon, IconProps } from '@chakra-ui/react'

export default function PersonThreeResponsibleIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#868E96'}
      {...props}
    >
      <path
        d="M13.8609 7.6831C14.3876 8.20979 14.3876 9.06372 13.8609 9.5904C13.3342 10.1171 12.4803 10.1171 11.9536 9.5904C11.4269 9.06371 11.4269 8.20979 11.9536 7.6831C12.4803 7.15641 13.3342 7.15641 13.8609 7.6831"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.46697 5.27523C10.278 6.08622 10.278 7.40109 9.46697 8.21209C8.65598 9.02307 7.34111 9.02307 6.53011 8.21209C5.71913 7.4011 5.71913 6.08623 6.53011 5.27523C7.3411 4.46425 8.65597 4.46425 9.46697 5.27523"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.0445 7.68212C4.57119 8.20881 4.57119 9.06274 4.0445 9.58942C3.51782 10.1161 2.66389 10.1161 2.1372 9.58942C1.61052 9.06274 1.61052 8.20881 2.1372 7.68212C2.66389 7.15544 3.51782 7.15544 4.0445 7.68212"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3335 13.9999V13.2692C15.3335 12.3485 14.5875 11.6025 13.6668 11.6025H13.1328"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.666016 13.9999V13.2692C0.666016 12.3485 1.41202 11.6025 2.33268 11.6025H2.86668"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5588 14.0003V12.9329C11.5588 11.6443 10.5141 10.5996 9.22545 10.5996H6.77279C5.48412 10.5996 4.43945 11.6443 4.43945 12.9329V14.0003"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
